import { render } from "./CodConduta.vue?vue&type=template&id=c5ceab7a"
import script from "./CodConduta.vue?vue&type=script&lang=js"
export * from "./CodConduta.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/WD 1/Development/Laravel/pessoalform_crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__